export default "__VITE_ASSET__BfvPvPPD__"